import * as stockOrder from "./stockOrder";
import * as stockQueryFacadeImpl from "./stockQueryFacadeImpl";
import * as stockSku from "./stockSku";

export const stock = {
  stockOrder,
  stockQueryFacadeImpl,
  stockSku,
};
